export class Currency {
  id?: number;
  code: string;
  name: string;
  symbol: string;
}
